import React from 'react'
import classnames from 'classnames'

export interface IChip {
  name: string | number
  iconLeft?: string
  iconRight?: string
  onClose?: React.MouseEventHandler<HTMLButtonElement>
  mouseEffect?: boolean
}

const Chip = ({ name, iconLeft, iconRight, onClose, mouseEffect = true }: IChip) => {
  return (
    <span
      className={classnames(
        'flex items-center rounded-lg px-4 py-1 font-spaceGrotesk text-sm text-white shadow-border-faded',
        {
          'pr-2': iconRight || onClose,
          'pl-2': iconLeft,
          'hover:bg-white hover:bg-opacity-20 active:shadow-border-main': mouseEffect,
        },
      )}>
      {iconLeft && <span className={`icon-${iconLeft} mr-2 text-xl`}></span>}
      <span className="py-1">{name}</span>
      {iconRight && <span className={`icon-${iconRight} ml-2 text-xl`}></span>}
      {onClose && (
        <span onClick={onClose} className="icon-close ml-4 cursor-pointer text-lg"></span>
      )}
    </span>
  )
}

export default Chip
